module.exports = __webpack_public_path__ + "img/sign_word.2356fb77.png";